import React from "react";

import {
  Form,
  Col,
  Row,
  message,
  Input,
  Layout,
  Button,
  DatePicker,
  Empty,
} from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";
import FormItem from "antd/lib/form/FormItem";
const { Content } = Layout;

class RequestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eSelectedTemplate: null,
      Assigned: null,
     
    };

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    if (this.props.location.state) {
      this.api.invoke(
        "GetServiceRequestById/" + this.props.location.state,
        "get",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              this.setState({ eSelectedTemplate: data.data });
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        }
      );
    }
  }

  ChangeStatus = (data) => {
    this.api.invoke(
      "ChangeServiceRequestStatus",
      "patch",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
           //  this.props.GetAllServiceRequestByUserId();
            this.props.history.push("/myrequests");
            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  };
  render() {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    const { srId, currentStatus } = this.state.eSelectedTemplate
      ? this.state.eSelectedTemplate
      : { srId: 0, currentStatus: "", nextStatus: "" };

    return (
      <Content>
        <div className="mi_main_div" style={{ padding: "40px" }}>
          <div className="mi_box">
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">
                  Service Request Id -{" "}
                  {this.state.eSelectedTemplate &&
                    this.state.eSelectedTemplate.srNumber}
                </h4>
              </Col>
              <Col span={6}>
                <img
                  alt="example"
                  style={{ height: "182px", marginTop: "-80px" }}
                  src={img}
                />
              </Col>
            </Row>
          </div>

          <div
            style={{
              marginLeft: "-8px",
              marginRight: "-8px",
            }}
          >
            <Row span={24} style={{ marginBottom: "-20px" }}>
              <Col span={4} style={{ marginTop: "30px" }}>
                <i
                  className="fas fa-arrow-left"
                  style={{
                    marginLeft: "8px",
                    fontSize: "24px",
                    color: "#4e5694",
                    width: "40px",
                  }}
                  onClick={() => {
                    this.props.history.push("/myrequests");
                  }}
                />
              </Col>
              <Col span={20} style={{ marginTop: "50px" }}>
                <div>
                  {currentStatus !== "Terminated" && role !== "member" && (
                    <Row style={{ marginTop: "-40px" }}>
                      {role === "broker" && (
                        <p>
                          {currentStatus !== "Closed" &&
                            currentStatus !== "Assigned" && (
                              <Button
                                style={{ float: "right" }}
                                onClick={() =>
                                  this.ChangeStatus({
                                    srId: srId,
                                    currentStatus: currentStatus,
                                    nextStatus: "Assigned",
                                  })
                                }
                                className="submit-button"
                                type="primary"
                              >
                                Assign
                              </Button>
                            )}
                        </p>
                      )}

                      <div>
                        {role === "broker" ? (
                          <p style={{ marginTop: "-14px" }}>
                            {currentStatus !== "Closed" &&
                              currentStatus !== "Terminated" &&
                              currentStatus !== "Assigned" && (
                                <Button
                                  style={{ float: "right" }}
                                  onClick={() =>
                                    this.ChangeStatus({
                                      srId: srId,
                                      currentStatus: currentStatus,
                                      nextStatus: "Closed",
                                    })
                                  }
                                  className="submit-button"
                                  type="primary"
                                >
                                  Close
                                </Button>
                              )}
                          </p>
                        ) : role === "carrier" ? (
                          <p style={{ marginTop: "-14px" }}>
                            {currentStatus !== "Closed" &&
                              currentStatus !== "Terminated" &&
                              currentStatus !== "Open" && (
                                <Button
                                  style={{ float: "right" }}
                                  onClick={() =>
                                    this.ChangeStatus({
                                      srId: srId,
                                      currentStatus: currentStatus,
                                      nextStatus: "Closed",
                                    })
                                  }
                                  className="submit-button"
                                  type="primary"
                                >
                                  Close
                                </Button>
                              )}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  )}
                  <di>
                    {currentStatus === "Open" && role === "member" ? (
                    
                      <Button
                        style={{ float: "right", marginTop: "-20px" }}
                        onClick={() =>
                          this.ChangeStatus({
                            srId: srId,
                            currentStatus: currentStatus,
                            nextStatus: "Terminated",
                          })
                        }
                        className="submit-button"
                        type="primary"
                      >
                        Terminated
                      </Button>
                    ) : (
                      ""
                    )}
                  </di>
                </div>
              </Col>
            </Row>
            <div className="mi_main">
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: 500,
                  marginLeft: "16px",
                  color: "black",
                }}
              >
                {this.props.location && this.props.location.name}
              </p>

              <Form layout="vertical" hideRequiredMark>
                {this.state.eSelectedTemplate &&
                this.state.eSelectedTemplate.fields.length > 0 ? (
                  this.state.eSelectedTemplate.fields.map((x) => {
                    if (x.fieldTypeName === "textarea") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Input.TextArea
                                  disabled
                                  type="text"
                                  style={{ height: "100px" }}
                                  autoComplete={"nope"}
                                  className="mi_input"
                                  placeholder={x.fieldPlaceHolder}
                                  defaultValue={x.fieldValue}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }

                    if (x.fieldTypeName === "text") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Input
                                  disabled
                                  className="mi_input"
                                  maxLength={40}
                                  type="text"
                                  placeholder={x.fieldPlaceHolder}
                                  defaultValue={x.fieldValue}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "date") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset className="mi_input_pop">
                                <legend className="legend-font">
                                  {" "}
                                  {x.fieldLabelName}
                                </legend>

                                <DatePicker
                                  disabled
                                  autoComplete={"nope"}
                                  format="MM/DD/YYYY"
                                  className="mi_input"
                                  placeholder={x.fieldPlaceHolder}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                    if (x.fieldTypeName === "email") {
                      return (
                        <Row span={24}>
                          <Col md={12} sm={24}>
                            <Form.Item>
                              <fieldset
                                style={{ height: "auto" }}
                                className="mi_input_pop"
                              >
                                <legend className="legend-font">
                                  {x.fieldLabelName}
                                </legend>

                                <Input
                                  disabled
                                  className="mi_input"
                                  maxLength={40}
                                  type="text"
                                  placeholder={x.fieldPlaceHolder}
                                  defaultValue={x.fieldValue}
                                />
                              </fieldset>
                            </Form.Item>
                          </Col>
                        </Row>
                      );
                    }
                  })
                ) : (
                  <Empty></Empty>
                )}
                <Row>
                  {this.state.eSelectedTemplate &&
                    this.state.eSelectedTemplate.comments && (
                      <Col md={12} sm={24}>
                        <Form.Item>
                          <fieldset
                            style={{ height: "auto" }}
                            className="mi_input_pop"
                          >
                            <legend className="legend-font">Comments</legend>

                            <Input.TextArea
                              disabled
                              type="text"
                              style={{ height: "100px" }}
                              autoComplete={"nope"}
                              className="mi_input"
                              defaultValue={
                                this.state.eSelectedTemplate.comments
                              }
                            />
                          </fieldset>
                        </Form.Item>
                      </Col>
                    )}
                </Row>
                <FormItem></FormItem>
              </Form>
            </div>
          </div>
        </div>
      </Content>
    );
  }
}

export default RequestView;
